// removed by extract-text-webpack-plugin
module.exports = {"pitch":"#282c31","brand":"#2f75c1","highlightLink":"UX__highlightLink___gVfb1","active":"UX__active___2P27D"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/UX.css
// module id = 2440
// module chunks = 0 1